import bytesToUuid from './bytesToUuid';
function uuidToBytes(uuid) {
    const bytes = [];
    uuid.replace(/[a-fA-F0-9]{2}/g, (hex) => {
        bytes.push(parseInt(hex, 16));
        return hex;
    });
    return bytes;
}
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str));
    const bytes = new Array(str.length);
    for (let i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i);
    }
    return bytes;
}
export function v35(name, version, hashfunc) {
    const generateUUID = function generateUUID(value, namespace, buf, offset = 0) {
        if (typeof value === 'string') {
            value = stringToBytes(value);
        }
        if (typeof namespace === 'string') {
            namespace = uuidToBytes(namespace);
        }
        if (!Array.isArray(value)) {
            throw TypeError('value must be an array of bytes');
        }
        if (!Array.isArray(namespace) || namespace.length !== 16) {
            throw TypeError('namespace must be uuid string or an array of 16 byte values');
        }
        const bytes = hashfunc(namespace.concat(value));
        bytes[6] = (bytes[6] & 0x0f) | version;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        if (buf !== undefined) {
            for (let idx = 0; idx < 16; ++idx) {
                buf[offset + idx] = bytes[idx];
            }
        }
        return buf !== undefined ? buf : bytesToUuid(new Uint8Array(bytes));
    };
    generateUUID.uuidname = name;
    generateUUID.DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
    generateUUID.URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
    return generateUUID;
}
export default v35;
